module.exports = __webpack_public_path__ + "static/andressa-coelho-logo-0b4305b5690955a139372bb206008311.svg";